import type React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useColorScheme } from '../../foundations/colorScheme';
import { tokens } from '../../design-system/tokens';
import { StatusPill } from './StatusPill';
import type { UserStatus } from './types';

export interface StatusVariationPreviewProps {
  readonly status: UserStatus;
}

export const StatusVariationPreview: React.FC<StatusVariationPreviewProps> = ({ status }) => {
  const scheme = useColorScheme();
  const colorScheme = scheme === 'dark' ? 'dark' : 'light';
  const colors = tokens.color.semantic[colorScheme];

  return (
    <View
      testID="status-variation-preview"
      style={[
        styles.container,
        { backgroundColor: colors.surface.secondary, borderColor: colors.border.primary },
      ]}
    >
      <Text style={[styles.label, { color: colors.text.primary }]}>Preview</Text>
      <StatusPill status={status} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: tokens.spacing.md,
    paddingVertical: tokens.spacing.sm,
    borderRadius: tokens.radius.md,
    borderWidth: 1,
  },
  // Uniform with the shared `Input` label: footnote / weight-500 / primary.
  label: {
    fontFamily: tokens.typography.fontFamily.base,
    fontSize: tokens.typography.fontSize.footnote,
    fontWeight: '500',
  },
});
